

import React from "react";
import {
  Box

} from "@mui/material";

import Logo from "../Logo/Logo";

const Header = () => {


  return (
    <Box
    position={{md: 'sticky', xs: 'static'}}
      sx={{
        top: 0,
        left: 0,
        zIndex: 1201,
        backgroundColor: "#fff",
        borderBottom: "1px solid #E6D9FE",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 3, md: 4 },
        height: "70px",
      }}
    >
    <Logo />

   
    </Box>
  );
};

export default Header;
